import React, { useState, useRef } from 'react';
import contactStyle from '../assets/css/contacts.css';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Success from './modals/Success';
import Api from './../__helpers/api';
import Error from './modals/Error';

//images
import loader from '../assets/images/contacts/loader.svg';
import phoneIcon from '../assets/images/contacts/phone-icon.png';
import mailIcon from '../assets/images/contacts/mail-icon.png';
import locationIcon from '../assets/images/contacts/location-icon.png';



function Contacts() {
    const [select, setSelect] = useState('Избор');
    const handleChange = е => {
        setSelect(е.target.value);
    };
    const initialValidations = {
        name: false,
        email: false,
        type: false,
        message: false,
    }
    const [contacts, setContacts] = useState({
        ...initialValidations,
        //modals
        successOverlay: false,
        successModal: false,
    })


    const laoderGif = useRef(null);
    const submitButton = useRef(null);

    const handleContacts = e => {
        laoderGif.current.style.display = 'block';
        submitButton.current.style.display = 'none';
        e.preventDefault();

        let contactsUrl = 'contacts';
        let data = new FormData(e.target);

        Api.post(contactsUrl, data)
            .then(res => {
                laoderGif.current.style.display = 'none';
                submitButton.current.style.display = 'block';

                if (res.status === 200 && res.data.success) {
                    setContacts(contacts => {
                        return {
                            ...contacts,
                            initialValidations
                        }
                    });

                    setContacts(contacts => {
                        return { ...contacts, successOverlay: true }
                    })
                    setTimeout(() => {
                        setContacts(contacts => {
                            return { ...contacts, successModal: true }
                        })
                    }, 100);
                }
            })
            .catch(error => {
                laoderGif.current.style.display = 'none';
                submitButton.current.style.display = 'block';

                let _err = error.response;
                if (_err && _err.status && _err.status === 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setContacts(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                } else {
                    if (_err && _err.data) {
                        if (_err.data.message) {
                        }
                    }
                }

                setContacts(contacts => {
                    return {
                        ...contacts,
                        errorOverlay: true,
                        errorMainMessage: Object.values(_err.data.errors)[0],
                    }
                })
                setTimeout(() => {
                    setContacts(contacts => {
                        return {
                            ...contacts,
                            errorModal: true
                        }
                    })
                }, 50);
            });
    }

    const handleSuccessOk = () => {
        setContacts(contacts => {
            return {
                ...contacts,
                successModal: false,
            }
        })
        setTimeout(() => {
            setContacts(contacts => {
                return {
                    ...contacts,
                    successOverlay: false,
                }
            })
        }, 1000);
    }

    return (
        <main style={contactStyle}>
            <Success
                blur={contacts.successOverlay}
                popup={contacts.successModal}
                mainMessage="Вашето съобщение беше изпратено успешно!"
                secondaryMessage="Очаквайте да се свържем с Вас на посочената Е-поща."
                acceptCallback={handleSuccessOk}
            />
            <section id="contactsBanner">

            </section>
            <section id="contacts">
                <div className="wrapper">
                    <h1>
                        Свържете се с нас
                    </h1>
                    <p>
                        Чрез контактната форма по-долу може да ни изпратите Вашите предложения или въпроси. Ние ще се свържем с Вас възможно най-скоро.
                    </p>
                    <div className="register-wrapper">
                        <form onSubmit={handleContacts} id="contactForm" className="left-part">
                            <h2>
                                Изпратете ни съобщение
                            </h2>
                            <div className="fields">
                                <div className="col">
                                    <div className="row">
                                        <TextField
                                            id="name"
                                            name="name"
                                            error={contacts.name === true ? true : false}
                                            label="Име и Фамилия*"
                                            placeholder="Въведете име и фамилия..."
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="row">
                                        <TextField
                                            id="email"
                                            name="email"
                                            error={contacts.email === true ? true : false}
                                            label="Е-поща*"
                                            placeholder="Въведете Е-поща..."
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="row">
                                        <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                            Статус
                                            </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-placeholder-label-label"
                                            id="demo-simple-select-placeholder-label"
                                            value={select}
                                            name="type"
                                            onChange={handleChange}
                                        >
                                            <MenuItem disabled>
                                                <em>Избор</em>
                                            </MenuItem>
                                            <MenuItem value={0}>Курсист</MenuItem>
                                            <MenuItem value={1}>Инструктор</MenuItem>
                                            <MenuItem value={2}>Друго</MenuItem>
                                        </Select>
                                    </div>
                                    <div className="row">
                                        <TextField
                                            id="phone"
                                            name="phone"
                                            label="Тел. номер"
                                            error={contacts.phone === true ? true : false}
                                            placeholder="Въведете тел. номер..."
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <TextField
                                    id="message"
                                    name="message"
                                    error={contacts.message === true ? true : false}
                                    label="Съобщение*"
                                    placeholder="Въведете съобщение..."
                                    fullWidth
                                    multiline
                                    rows="4"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            <div className="button-part">
                                <Button type="submit" ref={submitButton} form="contactForm" className="send">
                                    Изпращане
                                </Button>
                                <img src={loader} className="loader" ref={laoderGif} alt="loader" />
                            </div>
                        </form>
                        <div className="right-part">
                            <h2>
                                Информация за контакти
                            </h2>
                            <ul>
                                <li>
                                    <img src={phoneIcon} alt="phone" />
                                    <div>
                                        <p>
                                            +359 886 666 258
                                        </p>
                                    </div>
                                </li>
                                <li>
                                    <img src={mailIcon} alt="mail" />
                                    <div>
                                        <a href="mailto: info@avtoobuchenie.bg">
                                            team@avtoobuchenie.bg
                                        </a>
                                    </div>
                                </li>
                                <li>
                                    <img src={locationIcon} alt="facebook" />
                                    <div>
                                        <div>
                                            <a href="https://www.facebook.com/avtoobuchenie" target="_blank">
                                            facebook.com/AvtoObuchenie
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Contacts;
